import React from "react";

const SongHome = () => {
  return (
    <>
      <h2>Song Page is Under Development</h2>
    </>
  );
};

export default SongHome;
